import { Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import AddCompanyCard from "./AddCompanyCard";
import CompanyBulkCSVCard from "./CompanyBulkCSVCard";
import ForwardDealsCard from "./ForwardDealsCard";

const useStyles = makeStyles((theme) => ({
    image: {
        width: 80,
        height: 'auto',
    },
    mainText: {
        fontFamily: 'Inter',
        fontSize: '1.2rem',
        fontWeight: 500,
        color: theme.colors.neutral['600'],
    },
    secondText: {
        fontFamily: 'Lato',
        fontSize: '1.2rem',
        fontWeight: 400,
        color: theme.colors.neutral['600'],
        textAlign: 'center',
    },
    thirdText: {
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: 400,
        color: theme.colors.neutral['600'],
    },
    subText: {
        fontFamily: 'Inter',
        fontSize: '1.1rem',
        fontWeight: 400,
        color: theme.colors.neutral['600'],
    },
}));

const NoDashboardsFoundView: React.FC<{
    noDataYet?: boolean,
    noDataYetModal?: boolean,
    noCompaniesFound?: boolean,
    noCompaniesYet?: boolean,
}> = ({ noDataYet, noDataYetModal, noCompaniesYet, noCompaniesFound, }) => {
    const classes = useStyles();

    return (<>
        {(noDataYet) ? (<>
            <ForwardDealsCard fullPage />
        </>) : (noDataYetModal) ? (<>
            <Stack alignItems="center" justifyContent="center" width="100%" height="100%" mt={10}>
                <img src="../../images/missing-dashboard.png" alt="missing-dashboard" className={classes.image} />
                <Typography className={classes.thirdText} mt={3}>{`You don't yet have companies in Notissia.`}</Typography>
                <Stack spacing={1} alignItems="center" justifyContent="center" width="100%" mt={5}>
                    <Typography className={classes.mainText} color="#666666 !important">{`How to add companies to Notissia`}</Typography>
                    <Typography className={classes.thirdText}>{`(maximum 200 companies per month):`}</Typography>
                </Stack>
                <Stack direction="row" spacing={8} alignItems="center" justifyContent="center" width="100%" height="100%">
                    <ForwardDealsCard />
                    <AddCompanyCard  />
                    <CompanyBulkCSVCard />
                </Stack>
            </Stack>
        </>) : (noCompaniesYet) ? (<>
            <Stack alignItems="center" justifyContent="center" width="100%" height="100%">
                <img src="../../images/missing-dashboard.png" alt="missing-dashboard" className={classes.image} />
                <Typography className={classes.mainText} mt={4}>{'No companies yet!'}</Typography>
            </Stack>
        </>) : (noCompaniesFound) ? (<>
            <Stack alignItems="center" justifyContent="center" width="100%" height="100%">
                <img src="../../images/missing-dashboard.png" alt="missing-dashboard" className={classes.image} />
                <Typography className={classes.secondText} mt={4}>{'No companies found!'}</Typography>
            </Stack>
        </>) : (<>
            <Stack alignItems="center" spacing={1} justifyContent="flex-start" width="100%" height="100%" mt={5}>
                <img src="../../images/missing-dashboard.png" alt="missing-dashboard" className={classes.image} />
            </Stack>
        </>)}
    </>);
}

export default NoDashboardsFoundView;
